import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkeletonComponent } from './skeleton.component';

/**
 * Modulo proprio do app-skeleton, para o modulo de cada tela importar.
 *
 * O SharedModule tambem o reexporta (o LayoutModule usa por ali), mas so 3
 * dos 36 modulos de rota importam o SharedModule -- e ele traz 16 forRoot()
 * do ngx-bootstrap e o ToasterModule, que nao devem ser reprovidos em cada
 * modulo lazy. Este so depende do CommonModule.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [SkeletonComponent],
  exports: [SkeletonComponent]
})
export class SkeletonModule { }
